import { h } from "@sgwt-widget/core";

const userActionRequiredStyles = {
  color: "#b9292b", // @brand-danger
};

/**
 * Shows a message to the user allowing HTML content
 */
export const RawUserMessage = ({ children }: { children: JSX.Element }) => (
  <div style={userActionRequiredStyles}>
    {children}
  </div>
);
